import * as React from 'react';
import './EditItemPopup.scss';

import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { _getInputService } from '../../../../services/event.service';
import { IEditItemPopupProps, IEditItemPopupState } from '../../../../interfaces/IEditItemPopup';
import { MaxOrderItemDescription } from '../../../../constants/GlobalConstants';

export default class EditItemPopup extends React.Component<IEditItemPopupProps, IEditItemPopupState> {
    constructor(props: IEditItemPopupProps) {
        super(props);
    }

    public render() {
        return (
            <Dialog hidden={this.props.hideDialog} onDismiss={this.props._cancel}
                dialogContentProps={{
                    type: DialogType.largeHeader,
                    title: this.props.Id > 0 ? 'Artikel bewerken' : 'Artikel toevoegen',
                }}
                modalProps={{
                    isBlocking: false,
                    styles: { main: { maxWidth: 450 } }
                }} >
                <p>
                    <div className="ms-fontSize-16">{this.props.ItemTitle}</div>
                    <div className="text-muted">{this.props.ItemNo_MXI} / {this.props.ItemNo_RAI}</div>
                </p>
                <TextField label="Aantal*" name="Quantity" placeholder="Vul de hoeveelheid in" value={this.props.Quantity.toString()}
                    type="number"
                    onChange={(e, value) => this.props._onTextChangeEvent("Quantity", value || '')}
                    errorMessage={this.props.ErrorMessageOnQuantity}

                />
                <TextField label="Omschrijving" name="Description" placeholder="Vul de omschrijving in" multiline rows={3} maxLength={MaxOrderItemDescription} value={this.props.Description}
                    onChange={(e, value) => this.props._onTextChangeEvent("Description", value || '')}
                />
                <DialogFooter>
                    <DefaultButton onClick={this.props._cancel} text="Annuleer" />
                    <PrimaryButton onClick={this.props._submitData} text={this.props.Key !== '' ? "Opslaan" : "Voeg toe"} />
                </DialogFooter>
            </Dialog>
        );
    }
}
